var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-capsule-container"},[_c('b-card',[_c('b-row',[_c('b-col',{staticClass:"capsule-content-wrapper"},[(_vm.capsule)?_c('router-link',{staticClass:"open-capsule",attrs:{"tag":"div","to":{
            name: 'ShowCapsule',
            params: { capsuleId: _vm.capsule.id }
          }}},[_c('span',{staticClass:"text"},[_vm._v("Open")]),_c('i',{staticClass:"pe-7s-expand1 icon"})]):_vm._e(),_vm._v(" "),(_vm.capsule)?_c('CapsuleContent',{attrs:{"capsule":_vm.capsule}}):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b664b15","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blogEntry/BlogCapsule.vue
// module id = MGmo
// module chunks = 0